import { render, staticRenderFns } from "./AssignKnifeModal.vue?vue&type=template&id=5ce8e928&scoped=true"
import script from "./AssignKnifeModal.vue?vue&type=script&lang=js"
export * from "./AssignKnifeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8e928",
  null
  
)

export default component.exports